import { paymentStatuses } from "@/common/fields/orders-payment-status-codes";

export const HISTORY_SOURCES = {
    portal: "portal",
    webhook: "webhook",
    ecommerce: "ecommerce",
    system: "system"
};

export const PAYMENT_WEBHOOK_MESSAGE = "paymentWebhook";

export const resolveHistorySource = (entry = {}) => {
    if (entry.source) return entry.source;
    if (entry.madeBy === "webhook") return HISTORY_SOURCES.webhook;
    if (entry.madeBy) return HISTORY_SOURCES.portal;
    return HISTORY_SOURCES.system;
};

const toTime = (value) => {
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? 0 : time;
};

export const sortHistoryNewestFirst = (metadata = []) =>
    [...(Array.isArray(metadata) ? metadata : [])].sort(
        (a, b) => toTime(b.date) - toTime(a.date)
    );

export const formatHistoryValue = (value) => {
    if (value === undefined || value === null) return "";
    if (typeof value === "object") return JSON.stringify(value, null, 2);
    return String(value);
};

export const isPaymentConfirmedByWebhook = (order = {}) =>
    order.orderConfirmPaymentSource === HISTORY_SOURCES.webhook &&
    order.paymentStatus === paymentStatuses.approved;

export const getWebhookConfirmationDate = (order = {}) => {
    if (order.paymentAt) return order.paymentAt;
    const appliedWebhook = sortHistoryNewestFirst(order.metadata).find(
        (entry) =>
            entry.message === PAYMENT_WEBHOOK_MESSAGE &&
            entry.details &&
            entry.details.result === "applied"
    );
    return appliedWebhook ? appliedWebhook.date : null;
};
